export default {
    props: {
        topPadding: {
            type: Number,
            default: 50
        },
        bottomPadding: {
            type: Number,
            default: 50
        },
        mobileTopPadding: {
            type: Number,
            default: 30
        },
        mobileBottomPadding: {
            type: Number,
            default: 30
        }
    },
    data() {
        return {
            isMobile: typeof window !== 'undefined' ? window.innerWidth < 1024 : (this.$page?.props?.isMobileUA ?? false)
        }
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        handleResize() {
            this.isMobile = window.innerWidth < 1024;
        }
    },
    computed: {
        computedPaddingStyle() {
            return {
                paddingTop: `${this.isMobile ? this.mobileTopPadding : this.topPadding}px`,
                paddingBottom: `${this.isMobile ? this.mobileBottomPadding : this.bottomPadding}px`
            };
        }
    }
} 